export default __webpack_public_path__ + "static/media/closed_card-spider.68b7ae7b.png";